import { ReactComponent as EditIcon } from "../../assets/icons/tables/edit-icon.svg";
import { ReactComponent as TrashIcon } from "../../assets/icons/tables/trash-icon.svg";
import { Tooltip } from "@material-tailwind/react";
import { useNavigate } from "react-router";
import { useUsers } from "../../store/useUsers";
import { useMemo } from "react";
import { useAuth } from "../../store/useAuth";
import { Constants } from "../../utils/Constants";
import { useAlert } from "../../store/useAlert";

export const CommunityUsersTable = () => {
  /** Hooks */
  const navigate = useNavigate();
  const { allCommunityUsers: allUsers } = useUsers();
  const { permanentlyDeleteUser } = useAuth();
  const { setAlert } = useAlert();

  const filteredUsers = useMemo(() => {
    return allUsers?.filter((user) => !user?.pending_delete);
  }, [allUsers]);

  const UserRoles = {
    1: "Admin",
    2: "Manager",
    3: "User",
  };

  return (
    <div className="relative overflow-x-auto">
      <table className="w-full text-base font-normal font-satoshi text-left rtl:text-right text-dark">
        <thead className="font-medium bg-gray-50">
          <tr>
            <th
              scope="col"
              className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
            >
              Profile image
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Full name
            </th>
            <th
              scope="col"
              className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
            >
              User level
            </th>
            <th
              scope="col"
              className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
            >
              Postalcode
            </th>
            <th
              scope="col"
              className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
            >
              Platform
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Total Pay-out
            </th>
            {/* <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Total volume
            </th> */}
            <th
              scope="col"
              className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
            >
              Drops volume
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4 text-right">
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          {filteredUsers?.map((user) => (
            <tr
              key={user?._id}
              className={`${user?.pending_delete ? "bg-red-200" : "bg-white"} ${
                user?.pending_delete ? "hover:bg-red-300" : "hover:bg-gray-100"
              } cursor-pointer transition ease-linear border-b`}
            >
              <th
                onClick={() => navigate(`/edit-user/${user?._id}`)}
                scope="row"
                className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4 font-bold text-primary-base whitespace-nowrap"
              >
                <img
                  alt="profile-pic"
                  className="w-[40px] h-[40p] mr-3 rounded-full cursor-pointer"
                  src={
                    user?.profileImage ??
                    require("../../assets/pictures/dummy/dummy-avatar.png")
                  }
                />
              </th>
              <th
                onClick={() => navigate(`/edit-user/${user?._id}`)}
                scope="row"
                className="px-2 sm:px-6 py-1 sm:py-4 font-bold text-primary-base whitespace-nowrap"
              >
                {user?.first_name} {user?.last_name}{" "}
                <p className="text-red-900">
                  {user?.pending_delete && "(Pending delete)"}
                </p>
              </th>
              <td
                onClick={() => navigate(`/edit-user/${user?._id}`)}
                className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
              >
                <div
                  className={`py-[12px] px-[5px] rounded ${
                    user?.user_role === 1 && "bg-red-light"
                  } ${user?.user_role === 2 && "bg-primary-light"} ${
                    user?.user_role === 3 && "bg-blue-gray-300"
                  } flex flex-row items-center justify-center text-white font-satoshi font-bold`}
                >
                  {/* @ts-ignore */}
                  {UserRoles[Number(user?.user_role ?? 3)]}
                </div>
              </td>
              <td
                onClick={() => navigate(`/edit-user/${user?._id}`)}
                className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
              >
                {user?.postal_code}
              </td>
              <td
                onClick={() => navigate(`/edit-user/${user?._id}`)}
                className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
              >
                {user?.platform === "ios" && (
                  <img
                    className="w-[30px] h-[30px]"
                    alt="ios-logo"
                    src={require("../../assets/icons/platforms/apple.png")}
                  />
                )}
                {user?.platform === "android" && (
                  <img
                    className="w-[30px] h-[30px]"
                    alt="android-logo"
                    src={require("../../assets/icons/platforms/android.png")}
                  />
                )}
              </td>
              <td
                onClick={() => navigate(`/edit-user/${user?._id}`)}
                className="px-2 sm:px-6 py-1 sm:py-4"
              >
                {Number(
                  user?.totalRevenue ? user?.totalRevenue / 100 : 0
                )?.toFixed(2)}
                €
              </td>
              {/* <td
                onClick={() => navigate(`/edit-user/${user?._id}`)}
                className="px-2 sm:px-6 py-1 sm:py-4"
              >
                4
              </td> */}
              <td
                onClick={() => navigate(`/edit-user/${user?._id}`)}
                className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
              >
                {Number(user?.dropsVolume ?? 0) +
                  Number(user?.beevisionDropsVolume ?? 0) +
                  Number(user?.tomraDropsVolume ?? 0)}
              </td>
              <td className="px-2 sm:px-6 py-1 sm:py-4 flex items-center justify-end cursor-pointer">
                <Tooltip content="Edit">
                  <EditIcon
                    onClick={() => navigate(`/edit-user/${user?._id}`)}
                    className="mr-3 sm:mr-7"
                  />
                </Tooltip>
                <Tooltip content="Delete">
                  <TrashIcon
                    onClick={() => {
                      if (user?.phone_number === Constants.TEST_PHONE_NUMBER) {
                        return setAlert({
                          isOpen: true,
                          message: "You cannot delete this user",
                          severity: "error",
                        });
                      }
                      // A sub-cent remainder (e.g. 0.7, from drops priced before
                      // they were rounded) can't be paid out, so it isn't a balance.
                      const hasBalance = Number(user?.balance ?? 0) >= 1;
                      const confirmDelete = window.confirm(
                        hasBalance
                          ? `This user's balance is not zero (${(
                              Number(user?.balance ?? 0) / 100
                            ).toFixed(
                              2
                            )}€). Deleting is permanent and their balance will be lost. Are you sure you want to permanently remove this user?`
                          : "Are you sure you want to permanently remove this user?"
                      );
                      if (!confirmDelete) return;
                      // Recorded on the closure record, so a deletion can be
                      // accounted for later. Required, not optional.
                      // eslint-disable-next-line no-alert
                      const reason = window.prompt(
                        "Why is this account being removed? This is stored with the deletion record."
                      );
                      if (!reason?.trim()) {
                        return setAlert({
                          isOpen: true,
                          message: "A reason is required to remove an account.",
                          severity: "error",
                        });
                      }
                      permanentlyDeleteUser(user?._id as string, reason.trim());
                    }}
                  />
                </Tooltip>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
